import React from 'react';
import EditIcon from '@material-ui/icons/Edit';

import { SystemButton } from './ActionButton';
import { dealTokens } from './designTokens';

// Read-only summary of the Deal design system: titled groups of "label · value" rows, used
// by the reservation "Riepilogo" and the calendar event details. A group can carry an edit
// action (pencil) that sends the user back to the step or form that owns those values.

// One "label · value" line. `value` may be any node; an empty value shows a dash.
export const SummaryRow = ({ label, value }) => (
  <div style={{ display: 'flex', justifyContent: 'space-between', gap: dealTokens.space[3], padding: `${dealTokens.space[1]}px 0` }}>
    <span style={{ color: dealTokens.color.textMuted, fontSize: 13, flexShrink: 0 }}>{label}</span>
    <span
      style={{
        minWidth: 0,
        color: dealTokens.color.text,
        fontSize: 13,
        fontWeight: dealTokens.font.weightMedium,
        textAlign: 'right',
        overflowWrap: 'anywhere',
      }}
    >
      {value === 0 || value ? value : '—'}
    </span>
  </div>
);

// A titled group of rows, separated from the next group by a line (`last` drops it).
export const SummaryCategory = ({ title, editLabel, onEdit, action, children, last = false }) => (
  <div
    style={{
      borderBottom: last ? 'none' : `1px solid ${dealTokens.color.border}`,
      paddingBottom: last ? 0 : dealTokens.space[2],
      marginBottom: last ? 0 : dealTokens.space[2],
    }}
  >
    <div style={{ display: 'flex', alignItems: 'center', justifyContent: 'space-between', gap: dealTokens.space[2], minHeight: 28 }}>
      <span style={{ color: dealTokens.color.text, fontSize: 13, fontWeight: dealTokens.font.weightSemibold }}>{title}</span>
      {action}
      {onEdit && (
        <SystemButton
          type="button"
          variant="ghost"
          size="sm"
          icon={<EditIcon />}
          aria-label={editLabel}
          tooltip={editLabel}
          onClick={onEdit}
          style={{ width: 28, height: 28, minWidth: 28, minHeight: 28, padding: 0 }}
        />
      )}
    </div>
    {children}
  </div>
);
